export default {
  'footer.AboutUs': 'About Us',
  'footer.bit': 'BIT Token',
  'footer.Termsofservice': 'Service Terms',
  'footer.Termsofservice.link': 'https://biconomy.zendesk.com/hc/en-us/articles/360036401031-Terms-of-service',
  'footer.AboutBiconomy': 'About Biconomy',
  'footer.AboutBiconomy.link': 'https://biconomy.zendesk.com/hc/en-us/articles/360036039952-About-Biconomy',
  'footer.Team': 'Team',
  'footer.Team.link': 'https://biconomy.zendesk.com/hc/en-us/articles/900005556043-Dmitriy-Sheludko',
  'footer.Careers': 'Careers',
  'footer.Careers.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007242052-Careers',
  'footer.BussinessContacts': 'Business Contacts',
  'footer.BussinessContacts.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007242072-Business-Contacts',
  'footer.Products': 'Products',
  'footer.Products.link': 'https://biconomy.zendesk.com/hc/en-us/categories/360002352972-Products',
  'footer.LibraPlus': 'Libra Plus',
  'footer.LibraPlus.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007378591-Libra-Plus',
  'footer.ShotBit': 'ShotBit',
  'footer.ShotBit.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007283472-ShotBit',
  'footer.Info': 'Info',
  'footer.Info.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007251972-Info',
  'footer.Services': 'Services',
  'footer.Services.link': 'https://biconomy.zendesk.com/hc/en-us/categories/360002352892-Service',
  'footer.ListingApplication': 'Listings',
  'footer.ListingApplication.link': '/business/listings',
  //
  'footer.company': 'Company',
  'footer.news': 'News & Updates',
  'footer.news.link': 'https://biconomy.zendesk.com/hc/en-us/categories/360002398311-Announcements',
  'footer.trading': 'Trading',
  'footer.markets': 'Markets',
  'footer.markets.link': '/markets',
  'footer.exchange': 'Exchange',
  'footer.exchange.link': 'https://www.biconomy.com/exchange?coin=BTC_USDC',
  'footer.buycrypto': 'Direct Buying',
  'footer.buycrypto.link': 'https://www.biconomy.com/buycrypto',
  'footer.business': 'Business',
  'footer.ListingAccelerator': 'Accelerator',
  'footer.ListingAccelerator.link': '',
  'footer.ListingOtc': 'OTC',
  'footer.ListingOtc.link': 'https://www.biconomy.com/otc-web/en',
  'footer.ListingLearningCenter': 'Learning Center',
  'footer.ListingLearningCenter.link': '',
  'footer.Brand': 'Brand Kit',
  'footer.Brand.link': '/BrandKit',
  'footer.Launchpad': 'Launchpad',
  'footer.Launchpad.link': '/Launchpad',
  //
  'footer.TradingRules': 'Trading Rules',
  'footer.TradingRules.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007251712-Trading-Rules',
  'footer.API': 'API Documentation',
  'footer.API.link': 'https://github.com/BiconomyOfficial/apidocs',
  'footer.Support': 'Support',
  'footer.Support.link': 'https://biconomy.zendesk.com/hc/en-us/categories/360002362891-Support',
  'footer.FAQ': 'News Center',
  'footer.FAQ.link': 'https://biconomy.zendesk.com/hc/en-us',
  'footer.Contact': 'Contact Us',
  'footer.Contact.link': 'https://biconomy.zendesk.com/hc/en-us/requests/new',
  'footer.Fees': 'Fees',
  'footer.Fees.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007385271-Fees',
  'footer.Announcements': 'Announcements',
  'footer.Announcements.link': 'https://biconomy.zendesk.com/hc/en-us/categories/360002398311-Announcements',
  'footer.BeginnersGuide': 'Beginners Guide',
  'footer.BeginnersGuide.link': 'https://biconomy.zendesk.com/hc/en-us/sections/360007328812-Beginners-Guide',
  'footer.ambassadorPage': 'Ambassador',
  'footer.ambassadorPage.link': '/ambassadorPage',
  'biconomy_desc': 'Canadian Cryptocurrency Exchange with US MSB Licence',

  'footer.get_app': 'Get The App',

  'app_down': 'App Download',
  'Staking': 'Staking',
  'support_services': 'Support & Services',
  'listing_application': 'Listing Application',
  'launchpad_application': 'Launchpad Application',
  'ambassador_program': 'Ambassador Program',
  'legal': 'Legal',
  'terms_of': 'Terms of Use',
  'privacy_policy': 'Privacy Policy',
  'kyc_aml': 'KYC & AML',
  'support_center': 'Support Center',
  'beginner_guide': 'Beginner’s Guide',
  'community': 'community',
  'media_kit': 'Media Kit',
  'referral_program': 'Referral Program',
  'email_us': 'Email Us',
  'token_listing': 'Token Listing',
  'biconomy_earn': 'Biconomy Earn',
  'Futures Affiliate': 'Futures Affiliate',

  'Careers': 'Careers',
  "feedback_and_suggestions": "Feedback and Suggestions",
  "business_contacts": "Business Contacts",
  "submit_request": "Submit a Request"
};
